import { TsRestClient } from '@eluve/api-client-provider';
import { Logger } from '@eluve/logger-main';

import { AddAppointmentTagEvent, TaskHandler } from '../types';

export const addAppointmentTagHandler = ({
  client,
  logger,
}: {
  client: TsRestClient | null;
  logger: Logger;
}): TaskHandler<AddAppointmentTagEvent> => {
  return async (task, context) => {
    if (!client) {
      logger.error('API client is not available');
      throw new Error('API client not initialized');
    }

    const response = await client.adminAppointment.addAppointmentTag({
      body: {
        type: task.tag.type,
        key: task.tag.key,
        fileId: task.fileId,
        metadata: task.metadata,
      },
      params: {
        tenantId: context.tenantId,
        appointmentId: task.appointmentId,
      },
    });

    if (response?.status !== 200) {
      logger.warn('Failed to add appointment tag', {
        appointmentId: task.appointmentId,
        tag: task.tag,
      });

      throw new Error('Failed to add appointment tag');
    }
  };
};
